import React from 'react';
import Skeleton from 'react-loading-skeleton';

import * as S from './styles';

const SkeletonLoading: React.FC = () => {
  return (
    <S.ProductWrapper>
      <Skeleton width="100%" height={330} style={{ borderRadius: '12px' }} />
    </S.ProductWrapper>
  );
};

export default SkeletonLoading;
